<template>
  <slot name="menu" :selectedKeys="selectedKeys" :items="items"></slot>
</template>

<script setup>

/**
 * @author 友人a丶
 * @items 所属的所有路由项
 * @selectedKeys 选中的菜单
 * 根据路由自动生成菜单的架子
 * */

import {getChildren} from "@/router/common";
import {useRoute} from 'vue-router';
import {computed} from "vue";

/*当前路由*/
const route = useRoute();

/* 显示哪个路由下面的菜单 */
const props = defineProps({
  route: {
    default: '/'
  }
});

/*获取路由项*/
const items = getChildren(props.route);

/* 获取当前菜单的索引 */
const selectedKeys = computed({
  get() {
    return route.matched.map(item => {
      return item.path;
    });
  },
  set() {
  }
});
</script>
